import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { cld } from "../../utils/cld";

const Img15 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1757965880/15_e01hoq.jpg"

const Icon1 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758315490/icon_1_1_oyyzqq.png"
const Icon2 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758315490/icon_0_2_wrwdgn.png"
const Icon3 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758315490/icon_1_2_zd4nla.png"
const Icon4 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758315490/icon_0_0_fvunxo.png"
const Icon5 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758315490/icon_0_1_2_ysli79.png"
const Icon6 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758315490/icon_1_0_2_i9wbqw.png"

const Service = () => {
  const { t } = useTranslation();

  const leftCards = [
    { icon: Icon1, title: t('services.cards.makeup.title'),         text: t('services.cards.makeup.text'),         link: "/makeup"          },
    { icon: Icon3, title: t('services.cards.permanentMakeup.title'),text: t('services.cards.permanentMakeup.text'),link: "/permanent-makeup" },
    { icon: Icon2, title: t('services.cards.hairdresser.title'),    text: t('services.cards.hairdresser.text'),    link: "/hairdresser"      },
  ];

  const rightCards = [
    { icon: Icon4, title: t('services.cards.nails.title'),      text: t('services.cards.nails.text'),      link: "/nails"      },
    { icon: Icon5, title: t('services.cards.eyelashes.title'),  text: t('services.cards.eyelashes.text'),  link: "/eyelashes"  },
    { icon: Icon6, title: t('services.cards.depilation.title'), text: t('services.cards.depilation.text'), link: "/depilation" },
  ];

  const ServiceCard = ({ icon, title, text, link }) => (
    <Link
      to={link}
      style={{ textDecoration: "none", display: "block" }}
      className="vb-service-card-link"
    >
      <div
        className="vb-service-card"
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "20px",
          flexDirection: "row",
          textAlign: "left",
          background: "#fff",
          border: "1.5px solid rgba(144,81,15,0.10)",
          borderRadius: "20px",
          padding: "24px",
          boxShadow: "0 2px 16px rgba(0,0,0,0.04)",
          transition: "box-shadow 0.3s ease, transform 0.3s ease, border-color 0.3s ease",
          cursor: "pointer",
        }}
        onMouseEnter={e => {
          e.currentTarget.style.boxShadow = "0 16px 48px rgba(144,81,15,0.14)";
          e.currentTarget.style.transform = "translateY(-4px)";
          e.currentTarget.style.borderColor = "rgba(144,81,15,0.26)";
        }}
        onMouseLeave={e => {
          e.currentTarget.style.boxShadow = "0 2px 16px rgba(0,0,0,0.04)";
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.borderColor = "rgba(144,81,15,0.10)";
        }}
      >
        <div
          style={{
            width: "64px",
            height: "64px",
            background: "linear-gradient(135deg, rgba(144,81,15,0.10) 0%, rgba(212,169,106,0.14) 100%)",
            borderRadius: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            border: "1px solid rgba(144,81,15,0.12)",
          }}
        >
          <img
            src={cld(icon, { w: 72 })}
            alt={title}
            width="36"
            height="36"
            loading="lazy"
            decoding="async"
            style={{ width: "36px", height: "36px", objectFit: "contain" }}
          />
        </div>
        <div style={{ flex: 1 }}>
          <h4
            style={{
              fontFamily: "'Cormorant Garamond', 'PT Serif', serif",
              fontSize: "1.25rem",
              fontWeight: "600",
              letterSpacing: "-0.01em",
              margin: "0 0 8px 0",
              color: "#1A0D05",
              lineHeight: "1.25",
              transition: "color 0.25s ease",
            }}
          >
            {title}
          </h4>
          <p
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: "13.5px",
              lineHeight: "1.75",
              color: "#8B7B6B",
              margin: 0,
            }}
          >
            {text}
          </p>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              marginTop: "12px",
              fontFamily: "'Inter', sans-serif",
              fontSize: "12px",
              fontWeight: "600",
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              color: "#90510F",
            }}
          >
            {t('services.learnMore')}
            <svg width="12" height="10" viewBox="0 0 16 12" fill="none">
              <path d="M1 6h14M9 1l6 5-6 5" stroke="#90510F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
        </div>
      </div>
    </Link>
  );

  return (
    <section
      style={{
        padding: "120px 0",
        background: "#fff",
        position: "relative",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: "64px" }}>
        <p
          style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: "11px",
            fontWeight: "700",
            letterSpacing: "0.24em",
            textTransform: "uppercase",
            color: "#90510F",
            display: "inline-flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "16px",
          }}
        >
          <span style={{ display: "inline-block", width: "28px", height: "2px", background: "#90510F", borderRadius: "2px" }} />
          {t('services.eyebrow')}
          <span style={{ display: "inline-block", width: "28px", height: "2px", background: "#90510F", borderRadius: "2px" }} />
        </p>
        <h2
          style={{
            fontFamily: "'Cormorant Garamond', 'PT Serif', serif",
            fontSize: "clamp(1.8rem, 4vw, 3rem)",
            fontWeight: "600",
            letterSpacing: "-0.01em",
            color: "#1A0D05",
            margin: 0,
          }}
        >
          {t('services.heading')}
        </h2>
      </div>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          gap: "60px",
          padding: "0 24px",
          maxWidth: "1280px",
          margin: "0 auto",
        }}
      >
        {/* Left column */}
        <div
          style={{
            flex: "1 1 280px",
            minWidth: "260px",
            display: "flex",
            flexDirection: "column",
            gap: "48px",
          }}
        >
          {leftCards.map((card, i) => (
            <ServiceCard key={i} {...card} />
          ))}
        </div>

        {/* Center image */}
        <div
          style={{
            flex: "1.5 1 340px",
            display: "flex",
            justifyContent: "center",
            minWidth: "260px",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "100%",
              maxWidth: "440px",
            }}
          >
            <img
              src={cld(Img15, { w: 880 })}
              alt={t('services.imgAlt')}
              width="880"
              height="587"
              loading="lazy"
              decoding="async"
              style={{
                width: "100%",
                height: "580px",
                objectFit: "cover",
                borderRadius: "28px",
                boxShadow: "0 32px 80px rgba(0,0,0,0.16)",
                display: "block",
              }}
            />
            {/* Badge overlay */}
            <div
              style={{
                position: "absolute",
                bottom: "28px",
                left: "50%",
                transform: "translateX(-50%)",
                background: "rgba(255,255,255,0.92)",
                backdropFilter: "blur(12px)",
                borderRadius: "14px",
                padding: "14px 28px",
                textAlign: "center",
                boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
                whiteSpace: "nowrap",
              }}
            >
              <p
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: "11px",
                  fontWeight: "700",
                  letterSpacing: "0.18em",
                  textTransform: "uppercase",
                  color: "#90510F",
                  margin: "0 0 4px 0",
                }}
              >
                {t('services.experience.label')}
              </p>
              <p
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontSize: "28px",
                  fontWeight: "700",
                  color: "#1A0D05",
                  margin: 0,
                  lineHeight: 1,
                }}
              >
                {t('services.experience.value')}
              </p>
            </div>
          </div>
        </div>

        {/* Right column */}
        <div
          style={{
            flex: "1 1 280px",
            minWidth: "260px",
            display: "flex",
            flexDirection: "column",
            gap: "48px",
          }}
        >
          {rightCards.map((card, i) => (
            <ServiceCard key={i} {...card} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Service;
